/* eslint-disable no-const-assign */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import _, { identity } from 'lodash';
import JOI from 'joi-browser';
import './../../../assets/css/requestimates.css';
import Referral from "./referral";
import ReferralState from "./referralState";
import { HTTPService } from "./../../../services/httpService";
import { convertToUTC, convertFromUTC } from '../../../util/convert_timezone';
import ReactGA from 'react-ga4';

const API = new HTTPService();

class Referrals extends Component {
  state = {
    referrals: [],
    customerId: 0,
    customerName: "",
    customerEmail: "",
    selectedReferral: {},
    activePage: 1,
    startDate: moment().format("YYYY/MM/DD"),
    vin: "",
    vehicleEntered: {},
    vinGood: false,
    prevMode: "",
    userType: this.props.userType,
    typeId: this.props.typeId,
    user: this.props.user,
    companyName: this.props.companyName,
    company: this.props.company,
    hiddenList: false,
    authenticated: 0,
    action: "display",
    errors: {},
    showHelpVideo: false,
    data: {
      email: "",
      name: "",
      vin: ""
    }
  };

  schema = {
    email: JOI.string().email().required().label('email'),
    name: JOI.string().required().label('name'),
    vin: JOI.string().regex(/[A-HJ-NPR-Z0-9|a-hj-npr-z0-9]{17}/).required().label('vin')
  };

  async componentDidMount() {
    if (this.state.userType === "dealer") {
      const referralList = `/referrals/${this.state.user.User_id}`;
      const { data: referrals } = await API.get(referralList);
      this.setState({ referrals });
    } else if (this.state.userType === "installer") {
      const specialistReferralList = `/referrals/specialist/${this.state.typeId}`;
      const { data: referrals } = await API.get(specialistReferralList);
      this.setState({ referrals });
    }
  }

  capitalizeWords = (str) => {
    if (!str) return "";
    return str.split(" ").map(word => word.includes("-")
      ? word.split("-").map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join("-")
      : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(" ");
  }

  sendEmail = async (referral) => {
    const firstName = this.state.data.name.split(" ")[0];
    const vehicleModel = /\d/.test(this.state.vehicleEntered.Model)
      ? _.upperCase(this.state.vehicleEntered.Model)
      : _.capitalize(this.state.vehicleEntered.Model);
    const vehicleMake = this.capitalizeWords(this.state.vehicleEntered.Make);

    const segmentData = {
      customerId: this.state.customerId,
      dealer: this.props.companyName,
      year: this.state.vehicleEntered.ModelYear,
      make: vehicleMake,
      model: vehicleModel,
      firstName: _.capitalize(firstName),
      id: referral,
      email: this.state.data.email
    };

    await API.post(`/mailchimp/`, segmentData);
  };

  readVIN = async (vin) => {
    const { data: vehicle } = await API.get(`/vin/?Id=${vin}`);
    this.setState({ vehicleEntered: vehicle.Results[0] });
  };

  addReferral = async (referral) => {
    const { data: added } = await API.post(`/referrals/`, referral);
    return added;
  };

  addCustomer = async (customer) => {
    const { data: customerId } = await API.post(`/customers`, customer);
    this.setState({ customerId });
    return customerId;
  };

  addVehicle = async (vehicle) => {
    const { data: vehicleId } = await API.post(`/vehicles`, vehicle);
    this.setState({ vehicleId });
    return vehicleId;
  };

  handleVINChange = async (e) => {
    const vin = e.currentTarget.value.trim().toUpperCase();
    const vinGood = vin.length === 17 && /[A-HJ-NPR-Z0-9]{17}/.test(vin);
    this.setState({ vin, vinGood });
  };

  // Add these new methods to the Referrals class
  handleClaimReferral = async (referral) => {
    try {
      console.log('Claiming referral:', referral);

      console.log('Company Information:', this.props.company);
      
      const claimData = {
        specialist_name: this.state.company.Installer_Name,
        specialist_phone: this.state.company.installer_phone_number,
        specialist_email: this.state.company.installer_email,
        specialist_business: this.state.company.Installer_Name,
        referral_id: referral.referral_id,
        claim_token: referral.claim_token
      };
      
      const response = await API.post('/claimreferral', claimData);
      console.log('Claim response:', response);
      
      alert('Referral claimed successfully!');
      
      // Refresh the referral list to show updated status
      window.location.reload(); // This forces a full page refresh
      
    } catch (error) {
      console.error('Error claiming referral:', error);
      alert('Failed to claim referral. Please try again.');
    }
  };

  handleConvertToEstimate = (referral) => {
    console.log('Converting referral to estimate:', referral);
    
    // In handleConvertToEstimate (referrals.jsx)
    const referralData = {
      customer: referral.customer_id,
      customerName: referral.customer_name,
      customerEmail: referral.customer_Email_Address,
      vehicle: {
        vin: referral.VIN,
        year: referral.Year,
        make: referral.Make,
        model: referral.Model
      },
      referralId: referral.referral_id,
      requestedService: referral.requested_service
    };

    this.props.history.push('/newestimate', { referralData });
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = JOI.validate(obj, schema);
    return error ? error.details[0].message : null;
  };

  handleDataChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const data = { ...this.state.data };
    data[input.name] = input.value;

    this.setState({ data, errors });
  };

  handleOnClick = () => {
    this.setState({ action: "add" });
  };

  handleCancel = () => {
    this.setState({ 
      selectedService: 0, 
      selectedReferral: {}, 
      action: "display", 
      hiddenList: false 
    });
  };

  handleDelete = () => {
    this.setState({ 
      selectedService: 0, 
      selectedReferral: {}, 
      action: "display", 
      hiddenList: false 
    });
  };

  handleReferralSelect = (referral, isMobile = false) => {
    this.setState({ 
      selectedReferral: referral, 
      selectedService: 0, 
      activePage: 1, 
      vinGood: false,
      hiddenList: isMobile
    });
  };

  handleShowHelpVideo = () => {
    this.setState({ showHelpVideo: true });
  };

  handleCloseHelpVideo = () => {
    this.setState({ showHelpVideo: false });
  };

  handleSubmitReferral = async () => {
    await this.readVIN(this.state.data.vin);

    const vehicle = {
      year: this.state.vehicleEntered.ModelYear,
      make: this.capitalizeWords(this.state.vehicleEntered.Make),
      model: /\d/.test(this.state.vehicleEntered.Model)
        ? _.upperCase(this.state.vehicleEntered.Model)
        : _.capitalize(this.state.vehicleEntered.Model),
      vin: this.state.vehicleEntered.VIN
    };

    await this.addVehicle(vehicle);

    const prospect = {
      customerName: this.capitalizeWords(this.state.data.name),
      customerEmailAddress: this.state.data.email,
      owningInstaller: 0
    };

    await this.addCustomer(prospect);
    console.log('User Info:', this.props.user);

    const newReferral = {
      userId: this.props.user.User_id,
      customerId: this.state.customerId,
      vin: vehicle.vin,
      dateAdded: moment().format("YYYY/MM/DD hh:mm:ss"),
      dealerId: this.props.typeId,
      status: "NEW",
      refferingEmail : this.props.user.Email,
    };

    const sendThis = await this.addReferral(newReferral);
    alert("Sale Added to system");
    await this.sendEmail(sendThis);
    window.location = "/referrals";
  };

  render() {
    const { referrals, userType, action, selectedReferral, showHelpVideo, typeId } = this.state;
    const isEmptyList = !Array.isArray(referrals) || referrals.length === 0;
    const namePage = userType === "installer" ? "Leads" : "Referrals";
    const divStyle = { backgroundColor: '#A2E6C3' };
    const divHeight = { background: '#ffffff' };

    return (
      <React.Fragment>
        <h3 className="page-name d-lg-none d-sm-block" style={divStyle}>
          {namePage}
          {Object.keys(selectedReferral).length > 0 && (
            <button type="button" className="close" aria-label="Close" onClick={this.handleCancel}>
              <span aria-hidden="true">&times;</span>
            </button>
          )}
        </h3>

        <div className="row">
          <div className="col-lg-12 text-center d-none d-lg-block">
            {!isEmptyList && userType === "dealer" && (
              <h5 className="text-center">To view more detail of a referral, select one from the list.</h5>
            )}
            {isEmptyList && userType === "dealer" && (
              <h5>Create a new referral by clicking "New Referral".</h5>
            )}
            {!isEmptyList && userType === "installer" && (
              <h5 className="text-center">Select a lead to claim or convert to an estimate.</h5>
            )}
            {isEmptyList && userType === "installer" && (
              <h5>No leads available at this time. Check back later for new opportunities.</h5>
            )}
          </div>

          <div className="col-lg-4 text-center d-none d-lg-block">
            <h5 className="page-name p-3 mb-0 corners" style={divStyle}>{namePage}</h5>
            <ul className="list-group-fluid p-0 list-group-flush shadow bg-white corners">
              {userType === "dealer" && (
                <li className="list-group-item d-flex justify-content-center align-items-center corners">
                  <button
                    type="button"
                    onClick={this.handleOnClick}
                    className="button btn-success m-2 buttons"
                  >
                    New Referral
                  </button>
                  <button
                    type="button"
                    onClick={this.handleShowHelpVideo}
                    className="btn btn-link p-1 ml-2"
                    title="Click for help video"
                    style={{ fontSize: '16px', color: '#6c757d' }}
                  >
                    <i className="fa fa-question-circle"></i>
                  </button>
                </li>
              )}
              {userType === "installer" && (
                <li className="list-group-item d-flex justify-content-center align-items-center corners">
                  <h6 className="m-2">Available Leads</h6>
                </li>
              )}

              {!isEmptyList && referrals.map(item => (
                <li
                  onClick={() => this.handleReferralSelect(item)}
                  key={item.referral_id}
                  className={item.referral_id === selectedReferral.referral_id ? "list-group-item active" : "list-group-item"}
                >
                  <small>
                    <div className="row">
                      <div className="col-2">
                        <b>{convertFromUTC(item.date_added).format("ddd MMM D")}</b>
                      </div>
                      <div className="col-8">
                        <div className="row"><div className="col">{item.Year} {item.Make} {item.Model}</div></div>
                        <div className="row">
                          <div className="col">
                            {item.customer_name}
                          </div>
                        </div>
                        {userType === "dealer" && (
                          <div className="row"><div className="col">{moment(item.expiration_date).diff(moment(), 'days')} days remaining</div></div>
                        )}
                        {userType === "installer" && (
                          <div className="row">
                            <div className="col">
                              {item.specialist_action === 'available' ? 'Available to Claim' : this.formatReferralType(item.referral_type)}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-2">{this.iconState(item.status, item.specialist_action, item.referral_type)}</div>
                    </div>
                  </small>
                </li>
              ))}
            </ul>
          </div>

          {this.state.hiddenList === false && (
            <div className="col-lg-4 text-center d-lg-none d-sm-block">
              <ul className="list-group-fluid p-0 list-group-flush shadow bg-white">
                {userType === "dealer" && (
                  <li className="list-group-item d-flex justify-content-center align-items-center">
                    <button
                      type="button"
                      onClick={this.handleOnClick}
                      className="btn btn-success btn-lg mt-2 mb-2"
                    >
                      New Referral
                    </button>
                    <button
                      type="button"
                      onClick={this.handleShowHelpVideo}
                      className="btn btn-link p-1 ml-2"
                      title="Click for help video"
                      style={{ fontSize: '18px', color: '#6c757d' }}
                    >
                      <i className="fa fa-question-circle"></i>
                    </button>
                  </li>
                )}
                {userType === "installer" && (
                  <li className="list-group-item d-flex justify-content-center align-items-center">
                    <h6 className="m-2">Available Leads</h6>
                  </li>
                )}

                {!isEmptyList && referrals.map(item => (
                  <li
                    onClick={() => this.handleReferralSelect(item, true)}
                    key={item.referral_id}
                    className={item.referral_id === selectedReferral.referral_id ? "list-group-item active" : "list-group-item"}
                  >
                    <small>
                      <div className="row">
                        <div className="col-2">
                          <b>{convertFromUTC(item.date_added).format("ddd MMM D")}</b>
                        </div>
                        <div className="col-8">
                          <div className="row"><div className="col">{item.Year} {item.Make} {item.Model}</div></div>
                          <div className="row">
                            <div className="col">
                              {item.customer_name}
                            </div>
                          </div>
                          {userType === "dealer" && (
                            <div className="row"><div className="col">{moment(item.expiration_date).diff(moment(), 'days')} days remaining</div></div>
                          )}
                          {userType === "installer" && (
                            <div className="row">
                              <div className="col">
                                {item.specialist_action === 'available' ? 'Available to Claim' : this.formatReferralType(item.referral_type)}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="col-2">{this.iconState(item.status, item.specialist_action, item.referral_type)}</div>
                      </div>
                    </small>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {(Object.keys(selectedReferral).length > 0 || action === 'add') && (
            <div className="col-lg-8">
              <div className="shadow-sm p-2 corners" style={divStyle}>
                <button type="button" className="close d-none d-lg-block" onClick={this.handleCancel} aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <br />
                <Referral
                  selectedReferral={selectedReferral}
                  displayedList={referrals}
                  mode="referrals"
                  userType={userType}
                  typeId={typeId}
                  onCancel={this.handleCancel}
                  action={action}
                />
              </div>
              <div className="shadow-sm p-3 corners" style={divHeight}>
                <ReferralState
                  userType={userType}
                  typeId={typeId}
                  referral={selectedReferral}
                  displayedList={referrals}
                  startDate={this.state.startDate}
                  errors={this.state.errors}
                  name={this.state.data.name}
                  onNameChange={this.handleDataChange}
                  email={this.state.data.email}
                  onEmailChange={this.handleDataChange}
                  onDelete={this.handleDelete}
                  onVINChange={this.handleDataChange}
                  vin={this.state.data.vin}
                  vehicleEntered={this.state.vehicleEntered}
                  vinGood={this.state.vinGood}
                  onSubmit={this.handleSubmitReferral}
                  onCancel={this.handleCancel}
                  action={action}
                  onClaimReferral={this.handleClaimReferral}
                  onConvertToEstimate={this.handleConvertToEstimate}
                />
              </div>
            </div>
          )}

          {showHelpVideo && (
            <>
              <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.6)' }}>
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">How to Add a Referral</h5>
                      <button type="button" className="close" onClick={this.handleCloseHelpVideo}>
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body p-0">
                      <div style={{ width: '100%', aspectRatio: '16 / 12', minHeight: '480px' }}>
                        <iframe
                          src="https://scribehow.com/embed/How_To_Add_A_New_Referral_On_Jobvious__E4e5Z385QhKOKQuCPRsO0A?as=video"
                          width="100%"
                          height="100%"
                          allowFullScreen
                          style={{ border: 0 }}
                          title="How to Add a New Referral on Jobvious"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-backdrop fade show" onClick={this.handleCloseHelpVideo}></div>
            </>
          )}
        </div>
      </React.Fragment>
    );
  }

  formatReferralType = (referralType) => {
    const typeMap = {
      'dealer': 'Dealer Referral',
      'specialist': 'Web Site',
      'internal campaign': 'Internal Campaign',
      'returning customer': 'Returning Customer',
      'organic': 'Organic',
      'google': 'Google',
      'insta': 'Instagram',
      'instagram': 'Instagram',
      'facebook': 'Facebook',
      'yelp': 'Yelp'
    };

    const type = referralType?.toLowerCase() || '';
    return typeMap[type] || 'Dealer Referral';
  }

  getSourceIcon = (referralType) => {
    console.log('getSourceIcon called with:', referralType);
    const iconMap = {
      'dealer': { icon: 'fa-solid fa-handshake', tooltip: 'Dealer Referral' },
      'specialist': { icon: 'fa-solid fa-user-doctor', tooltip: 'Specialist' },
      'internal campaign': { icon: 'fa-solid fa-bullhorn', tooltip: 'Internal Campaign' },
      'returning customer': { icon: 'fa-solid fa-arrow-rotate-right', tooltip: 'Returning Customer' },
      'organic': { icon: 'fa-solid fa-seedling', tooltip: 'Organic' },
      'google': { icon: 'fa-brands fa-google', tooltip: 'Google' },
      'insta': { icon: 'fa-brands fa-instagram', tooltip: 'Instagram' },
      'instagram': { icon: 'fa-brands fa-instagram', tooltip: 'Instagram' },
      'facebook': { icon: 'fa-brands fa-facebook', tooltip: 'Facebook' },
      'yelp': { icon: 'fa-brands fa-yelp', tooltip: 'Yelp' }
    };

    const type = referralType?.toLowerCase() || '';
    const iconData = iconMap[type] || { icon: 'fa-solid fa-handshake', tooltip: 'Dealer Referral' };
    console.log('Returning icon:', iconData);
    return <i className={iconData.icon} title={iconData.tooltip} />;
  }

  iconState = (state, specialistAction, referralType) => {
    // For specialists viewing referrals, use their action status for early stages only
    if (this.state.userType === "installer" && specialistAction) {
      switch (specialistAction) {
        case "available": return <i className="fa-solid fa-handshake" title="Dealer Referral"></i>; // OFFERED state - always dealer
        case "owned": return this.getSourceIcon(referralType); // CLAIMED state - show source
        default: return <i className="fa-solid fa-circle-question"></i>;
      }
    }

    // For dealers viewing referrals (all stages)
    switch (state) {
      // Early referral stages - referral-specific icons
      case "NEW": return <i className="fa-solid fa-folder" title="New" />;
      case "CONTACT": return <i className="fa-solid fa-envelope" title="Contact" />;
      case "VIEWED": return <i className="fa-solid fa-envelope-open" title="Viewed" />;
      case "OFFERED": return <i className="fa-solid fa-wrench" title="Offered" />;
      case "CLAIMED": return this.getSourceIcon(referralType); // Show source when claimed
      case "CONVERTED": return <i className="fa-solid fa-comment" title="Converted" />; // Speech bubble for quote/estimate


      // Job progression stages - job icons (after conversion)
      case "SCHEDULED": return <i className="fa-solid fa-calendar" />;
      case "RECEIVED": return <i className="fa-solid fa-battery-empty" />;
      case "STARTED": return <i className="fa-solid fa-battery-half" />;
      case "FINISHED": return <i className="fa-solid fa-car" />;
      case "COMPLETED": return <i className="fa-solid fa-dollar-sign" />;
      case "BOOKED": return <i className="fa-solid fa-calendar" />;

      default: return null;
    }
  }
}

export default withRouter(Referrals);